import { render, staticRenderFns } from "./UserChange.vue?vue&type=template&id=3c3901fe&scoped=true&"
import script from "./UserChange.vue?vue&type=script&lang=js&"
export * from "./UserChange.vue?vue&type=script&lang=js&"
import style0 from "./UserChange.vue?vue&type=style&index=0&id=3c3901fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3901fe",
  null
  
)

export default component.exports